import Spinner from "components/commun/Spinner";
import { useState } from "react";
import FiltersDataCards from "../filters/FiltersDataCards";
import MachinesDataCards from "../machines/MachinesDataCards";

function ProductsLists({ filterSearch, machineSearch, typeSearch }) {
  const [isLoading, setIsLoading] = useState(false);
  return (
    <>
      {isLoading && <Spinner />}
      {filterSearch ? (
        <FiltersDataCards
          filterSearch={filterSearch}
          isLoading={isLoading}
          setIsLoading={setIsLoading}
        />
      ) : machineSearch || typeSearch ? (
        <MachinesDataCards
          machineSearch={machineSearch}
          typeSearch={typeSearch}
          isLoading={isLoading}
          setIsLoading={setIsLoading}
        />
      ) : null}
    </>
  );
}

export default ProductsLists;
